import { SelectOption } from "atoms/forms/select";
import SubscriptionRecord from "models/view-models/subscription-record";
import { useQuery } from "react-query";
import RoleType from "utilities/enumerations/role-type";
import SubscriptionService from "utilities/services/subscriptions/subscription-service";
const SUBSCRIPTIONS_QUERY_KEY = "subscriptions";
const useSubscriptionOptions = () => {
    const { data, isLoading } = useQuery({
        queryKey: [SUBSCRIPTIONS_QUERY_KEY],
        queryFn: async () => await SubscriptionService.list(),
        keepPreviousData: true,
    });

    const subscriptions = data?.resultObjects;
    const subscriptionOptions: SelectOption<SubscriptionRecord, string>[] =
        subscriptions?.map((subscription) => {
            return {
                data: subscription,
                label: subscription.description,
                value: `${subscription.id}`,
            };
        }) ?? [];

    const subscriptionOptionsWithPlaceholder = [
        { label: "All subscriptions", value: "" },
        ...subscriptionOptions,
    ];

    const teamOrEnterpriseSubscriptionOptions =
        subscriptionOptionsWithPlaceholder.filter(
            (sub) =>
                sub.data?.roleType === RoleType.TEAM ||
                sub.data?.roleType === RoleType.ENTERPRISE ||
                !sub.value
        );

    return {
        subscriptionOptions,
        subscriptionOptionsWithPlaceholder,
        isLoading,
        teamOrEnterpriseSubscriptionOptions,
    };
};

export default useSubscriptionOptions;
